import { render, staticRenderFns } from "./ItemMessenger.vue?vue&type=template&id=674005fe&scoped=true&"
import script from "./ItemMessenger.vue?vue&type=script&lang=js&"
export * from "./ItemMessenger.vue?vue&type=script&lang=js&"
import style0 from "./ItemMessenger.vue?vue&type=style&index=0&id=674005fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674005fe",
  null
  
)

export default component.exports